import React from 'react';
import styles from './Toggle.module.css';
import classNames from 'classnames';

export type ToggleValue = 'left' | 'right';

interface ToggleProps {
  leftText: string;
  rightText: string;
  selectedValue: ToggleValue;
  onChange: (value: ToggleValue) => void;
  disabled?: boolean;
  className?: string;
}

const Toggle: React.FC<ToggleProps> = ({
  leftText,
  rightText,
  selectedValue,
  onChange,
  disabled = false,
  className = '',
}) => {
  const isRight = selectedValue === 'right';

  const handleToggle = () => {
    if (disabled) return;
    onChange(isRight ? 'left' : 'right');
  };

  return (
    <div className={classNames(styles.wrapper, className)}>
      <span
        className={classNames(styles.label, {
          [styles.inactiveLabel]: isRight,
        })}>
        {leftText}
      </span>
      <div
        className={classNames(styles.toggle, {
          [styles.disabled]: disabled,
          [styles.right]: isRight,
        })}
        onClick={handleToggle}
        role="switch"
        aria-checked={isRight}
        aria-disabled={disabled}>
        <div className={styles.ball} />
      </div>
      <span
        className={classNames(styles.label, {
          [styles.inactiveLabel]: !isRight,
        })}>
        {rightText}
      </span>
    </div>
  );
};

export default Toggle;
